// extracted by extract-css-chunks-webpack-plugin
module.exports = {"newHeaderHamburger":"Uu1gO","verticalSlide":"MJ-lu","visible":"ZzcPD","menuWrapper":"JryqS","loadingCircle":"nMc2b","loading-spinner":"o4D5d"};